import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/SetLang.tsx");
